import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setCurrentTV } from '../../../action/tvChannelAction'
import { tvWidgetColors } from '../../JS/colorConfig'
import {withTranslation} from "react-i18next";
import { CMSPath } from '../../../config/constant';

class TVSelect extends Component {

    componentDidMount() {
        // tvWidgetColors(this.props.menuColor)
    }

    onTVSelect = (TVdata) => {
        this.props.setCurrentTV(TVdata);
    }

    render() {
        const { t } = this.props
        return (
            <div class="main-container background-overlay"
                style={{ background: "url('theme/images/background/08MEDubai-Atrium.jpg') center center no-repeat; background-size: cover;background-attachment: fixed;" }}>
                <header class="inner-pages w-footer subpages" style={{
                    backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                }}>
                    <a href="javascript:window.history.back(-1);" class="button-back"></a>
                    <div class="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p class="bold" style={{
                            color:this.props.menuColor.assetFontSelectorColor,
                            textShadow:"unset"
                        }}>{this.props.currentWidget.widgetTitle}</p> */}
                    </div>
                </header>
                <section id="tvControls" class="widgets margin-0 padding-top-1 container-bg">

                    <div class="widget-header widget-header-checkin">
                        { this.props.currentWidget.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidget.widgetHeaderImageUrl}`} alt={this.props.currentWidget.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{this.props.currentWidget.displayName}</div>
                    </div>


                    {this.props.roomRemoteDetails.length > 0 ?
                        < div class="widgets">
                            <div class="row">
                                <center><p><strong>{t('room_control.tv_control.tv_select_txt')}</strong></p></center>
                            </div>
                            {
                                this.props.roomRemoteDetails.map((iterator, index) => {
                                    return (
                                        <div class="row align-center padding-top-1" onClick={this.props.roomRemoteDetails.length === 1 ? this.onTVSelect(iterator) : () => this.onTVSelect(iterator)}>
                                            <a>
                                                <div class="tv-label">
                                                    {iterator.deviceName !== "null" ? iterator.deviceName : index === 0 ? " TV" : ` TV ${index}`}
                                                </div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="214" height="148" viewBox="0 0 214 148">
                                                <defs>
                                                <filter id="a" width="136.6%" height="314.3%" x="-18.3%" y="-107.1%" filterUnits="objectBoundingBox">
                                                    <feGaussianBlur in="SourceGraphic" stdDeviation="10"/>
                                                </filter>
                                                </defs>
                                                <g fill="none" fill-rule="evenodd" transform="translate(16 2)">
                                                <path fill="#333" d="M9 93h164v28H9z" filter="url(#a)" opacity=".351"/>
                                                <rect width="191" height="114" fill="#FFF" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" rx="6"/>
                                
                                                <path fill="#FFF" stroke="#333" stroke-width="3" d="M73 114h45v17H73z"/>
                                                <path fill="#FFF" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M50.392 131.5h90.216"/>
                                                </g>
                                                </svg>
                                            </a>
                                        </div>
                                        // <div onClick={() => this.onTVSelect(iterator)} class="row align-center padding-top-1">
                                        //     <a>
                                        //         <svg xmlns="http://www.w3.org/2000/svg" width="214" height="148" viewBox="0 0 214 148">
                                        //             <defs>
                                        //                 <filter id="a" width="136.6%" height="314.3%" x="-18.3%" y="-107.1%" filterUnits="objectBoundingBox">
                                        //                     <feGaussianBlur in="SourceGraphic" stdDeviation="10" />
                                        //                 </filter>
                                        //             </defs>
                                        //             <g fill="none" fill-rule="evenodd" transform="translate(16 2)">
                                        //                 <path fill="#333" d="M9 93h164v28H9z" filter="url(#a)" opacity=".351" />
                                        //                 <rect width="191" height="114" fill="#FFF" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" rx="6" />
                                        //                 <text fill="#333" font-size="15" font-weight="500">
                                        //                     <tspan className="changesTextColor" x="50.537" y="59">
                                        //                         {iterator.deviceName !== "null" ? iterator.deviceName : index === 0 ? " TV" : ` TV ${index}`}
                                        //                     </tspan>
                                        //                 </text>
                                        //                 <path fill="#FFF" stroke="#333" stroke-width="3" d="M73 114h45v17H73z" />
                                        //                 <path fill="#FFF" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M50.392 131.5h90.216" />
                                        //             </g>
                                        //         </svg>
                                        //     </a>
                                        // </div>
                                    )
                                })
                            }
                        </div> :
                        <div>
                            {t('room_control.tv_control.no_tv_txt')}
                    </div>
                    }
                </section>

            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        currentWidget: state.store.sideNavBar.currentWidget,
        roomRemoteDetails: state.store.tvChannels.roomRemoteDetails,
        menuColor: state.store.home.MenuColor,
        currentWidget: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentTv: state.store.tvChannels.currentTv
    }
}
export default connect(
    mapStateToProps,
    {
        setCurrentTV
    }
)(withTranslation('translations')(TVSelect));